import React from "react";
import CrudPage from "./CrudPage";
export default function AdminActivities() {
  return <CrudPage title="Kegiatan" endpoint="activities" testPrefix="activity" fields={[
    {key: "title", label: "Judul"},
    {key: "category", label: "Kategori"},
    {key: "date", label: "Tanggal (YYYY-MM-DD)"},
    {key: "location", label: "Lokasi"},
    {key: "description", label: "Deskripsi", type: "textarea"},
    {key: "photo_url", label: "URL Foto"},
  ]} />;
}
